<template>
  <div class="content">
    <div>
      <img class="icon icon--link icon--bottom" src="@images/arrow-left.svg" v-svg-inline>
      <router-link :to="{ name: 'secretary.index' }">Вернуться назад</router-link>
    </div>

    <h1>{{ secretaryStore.form.full_name }}</h1>

    <ul class="tabs tabs--wrap">
      <router-link class="tabs__item" :class="{ 'tabs__item--active': activeTab === 'form' }" :to="{ name: 'secretary.form', params: { id: route.params.id, tab: 'form' } }">Анкета</router-link>
      <router-link class="tabs__item" :class="{ 'tabs__item--active': activeTab === 'applications' }" :to="{ name: 'secretary.form', params: { id: route.params.id, tab: 'applications' } }">Заявления</router-link>
      <router-link class="tabs__item" :class="{ 'tabs__item--active': activeTab === 'exams' }" :to="{ name: 'secretary.form', params: { id: route.params.id, tab: 'exams' } }">Экзамены</router-link>
      <router-link class="tabs__item" :class="{ 'tabs__item--active': activeTab === 'contest_list'}" :to="{ name: 'secretary.form', params: { id: route.params.id, tab: 'contest_list' } }">Моя конкурсная ситуация</router-link>
    </ul>

    <div v-if="loading" class="content content--center">
      <p>Загрузка...</p>
    </div>

    <component
      v-else
      readonly
      :is="TABS[activeTab]"
      :form="secretaryStore.form"
      :applications="secretaryStore.applications"
      :form-id="route.params.id"
      @select="(app) => router.push({ name: 'secretary.application', params: { formId: route.params.id, applicationId: app.id, section: 'overview' } })"
      @refetch-form="fetchSecretaryForm"
    />
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useSecretaryStore } from '@pages/secretary'
import { FormProfileFormTab, FormProfileApplicationsTab, FormProfileExamsTab, FormProfileContestTab } from '@widgets/form-profile'

const TABS = {
  form: FormProfileFormTab,
  applications: FormProfileApplicationsTab,
  exams: FormProfileExamsTab,
  contest_list: FormProfileContestTab,
}

const route = useRoute()
const router = useRouter()
const secretaryStore = useSecretaryStore()
const loading = ref(true)
const activeTab = computed(() => route.params.tab || 'form')

const fetchSecretaryForm = async (showLoading = false) => {
  if (showLoading) loading.value = true
  try {
    await secretaryStore.fetchForm(route.params.id)
  } finally {
    if (showLoading) loading.value = false
  }
}

onMounted(() => fetchSecretaryForm(true))
</script>
